import { z } from 'zod';
import { FindingSeveritySchema } from '@terra/shared-schemas-orchestrator';

export const FindingSeverityChangeRequestStatusSchema = z.enum([
  'Pending',
  'Approved',
  'Rejected',
]);

export type FindingSeverityChangeRequestStatus = z.infer<
  typeof FindingSeverityChangeRequestStatusSchema
>;

export const SubmitSeverityChangeRequestBodySchema = z.object({
  proposedSeverity: FindingSeveritySchema,
  justification: z.string().trim().min(20).max(2000),
});

export type SubmitSeverityChangeRequestBody = z.infer<
  typeof SubmitSeverityChangeRequestBodySchema
>;

export const DecideSeverityChangeRequestBodySchema = z.discriminatedUnion(
  'decision',
  [
    z.object({
      decision: z.literal('Approved'),
    }),
    z.object({
      decision: z.literal('Rejected'),
      reason: z.string().trim().min(1).max(2000),
    }),
  ],
);

export type DecideSeverityChangeRequestBody = z.infer<
  typeof DecideSeverityChangeRequestBodySchema
>;

const SeverityChangeRequestBaseSchema = z.object({
  id: z.string(),
  findingId: z.string(),
  applicationId: z.string(),
  fromSeverity: FindingSeveritySchema,
  toSeverity: FindingSeveritySchema,
  justification: z.string(),
  requestedByUserId: z.string(),
  requestedByName: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

const SeverityChangeRequestReviewSchema = z.object({
  reviewedByUserId: z.string(),
  reviewedByName: z.string(),
  reviewedAt: z.coerce.date(),
});

export const SeverityChangeRequestSchema = z.discriminatedUnion('status', [
  SeverityChangeRequestBaseSchema.extend({
    status: z.literal('Pending'),
  }),
  SeverityChangeRequestBaseSchema.extend(
    SeverityChangeRequestReviewSchema.shape,
  ).extend({
    status: z.literal('Approved'),
  }),
  SeverityChangeRequestBaseSchema.extend(
    SeverityChangeRequestReviewSchema.shape,
  ).extend({
    status: z.literal('Rejected'),
    rejectionReason: z.string(),
  }),
]);

export type SeverityChangeRequest = z.infer<typeof SeverityChangeRequestSchema>;
